import * as React from 'react'
import { ApplicationArchitectureNodeModel } from './application-architecture-node-model'
import { ApplicationArchitectureNodeWidget } from './application-architecture-node-widget'
import { AbstractReactFactory } from '@projectstorm/react-canvas-core'
import { DiagramEngine } from '@projectstorm/react-diagrams-core'
import { nodeType } from './index'

export class ApplicationArchitectureNodeFactory extends AbstractReactFactory<
  ApplicationArchitectureNodeModel,
  DiagramEngine
> {
  public constructor() {
    super(nodeType)
  }

  public generateModel() {
    return new ApplicationArchitectureNodeModel()
  }

  public generateReactWidget(event): JSX.Element {
    return (
      <ApplicationArchitectureNodeWidget
        engine={this.engine as DiagramEngine}
        node={event.model}
      />
    )
  }
}
